<template>
  <div class="main">
    <div class="main_bg">
      <div class="banner">
        <img
          src="../../assets/csr/imgsMobile/MbannerNoWords@2x.png"
          style="width: 100%"
        />
        <div class="wenben">
          <div>2015年9月，联合国193个成员国在可持续发展首脑会议上通过了联合国可持续发展目标( Sustainable Development Goals)。这一目标包含了17个重大目标，旨在完成千年发展目标遗留下的任务，指导2015-2030年的全球发展工作，解决包括贫困、饥饿、疾病、不平等、气候变化、生态破坏等全人类共同面对的问题。</div>
          <div>In September 2015, the 193 member states of the United Nations adopted the Sustainable Development Goals at the Sustainable Development summit. The goal, which contains 17 major goals, aims to accomplish the tasks left over from the Milennium Development Goals, guide global development from 2015 to 2030, and address the common problems facing all mankind, including poverty, hunger, disease, inequality, climate change and ecological destruction.</div>
          <div style="margin-top: 10px;">在17项目标指引下，上汽大众积极推动全价值链的企业社会责任，从合规经营、产品、 零碳之路、 员工、伙伴责任以及社会公益六个方面出发，积极探索并助推企业和社会的共同可持续发展。</div>
          <div>Under the guidance of 17 goals, SAIC VOLKSWAGEN actively promotes the corporate social responsiblity of the whole value chain, and actively explores and promotes the common sustainable development of the enterprise and society from six aspects, namely compliance management, product, Way to Zero, employee, partnership and social public welfare.</div>
        </div>
      </div>
      <sceneMenuPc></sceneMenuPc>
      <scene1Pc v-if="layoutShow(0)"></scene1Pc>
      <scene2Pc v-if="layoutShow(1)"></scene2Pc>
      <scene3Pc v-if="layoutShow(2)"></scene3Pc>
      <scene4Pc v-if="layoutShow(3)"></scene4Pc>
      <scene5Pc v-if="layoutShow(4)"></scene5Pc>
      <scene6Pc v-if="layoutShow(5)"></scene6Pc>
      <scene7Pc v-if="layoutShow(6)"></scene7Pc>
      <scene8Pc v-if="layoutShow(7)"></scene8Pc>
      <scene9Pc v-if="layoutShow(8)"></scene9Pc>
      <sceneEndPc></sceneEndPc>
    </div>
  </div>
</template>

<script>
import { csvw_url } from "../../components/config";
import config from "./config";
import sceneMenuPc from "./sceneMenuMobile.vue";
import sceneEndPc from "./sceneEndMobile.vue";
import scene1Pc from "./scene1Mobile.vue";
import scene2Pc from "./scene2Mobile.vue";
import scene3Pc from "./scene3Mobile.vue";
import scene4Pc from "./scene4Mobile.vue";
import scene5Pc from "./scene5Mobile.vue";
import scene6Pc from "./scene6Mobile.vue";
import scene7Pc from "./scene7Mobile.vue";
import scene8Pc from "./scene8Mobile.vue";
import scene9Pc from "./scene9Mobile.vue";
export default {
  components: {
    sceneMenuPc,
    sceneEndPc,
    scene1Pc,
    scene2Pc,
    scene3Pc,
    scene4Pc,
    scene5Pc,
    scene6Pc,
    scene7Pc,
    scene8Pc,
    scene9Pc,
  },
  data() {
    return {
      btnIndex: 0,
    };
  },
  beforeMount() {},
  mounted() {
    console.log(this);
  },
  methods: {
    // 板块是否展开
    layoutShow(val = 0) {
      if (val == this.btnIndex) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  min-width: 375px;
  margin: 0px auto;
  font-size: 12px;
  font-family: "Microsoft Yahei", "微软雅黑";
}

.main_bg {
  width: 100%;
  min-width: 375px;
  background: #ffffff;
}

.banner{
  position: relative;
}

.wenben{
  /*padding:20px 20px 0;*/
  position: absolute;
  top:0;
  left: 0;
  right: 0;
  transform: scale(0.9);
  font-size: 12px;
  /*font-weight: 600;*/
  /*color: #696969;*/
  /*>div{*/
  /*  margin-top: 10px;*/
  /*}*/
}
</style>
